var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4622 2.35301L1.69616 5.67163C1.59718 5.69955 1.50907 5.75702 1.44362 5.83635C1.37817 5.91568 1.3385 6.0131 1.3299 6.11559C1.32129 6.21807 1.34418 6.32074 1.39549 6.40988C1.4468 6.49901 1.5241 6.57036 1.61704 6.61438L7.02309 9.17514C7.12853 9.22509 7.21344 9.30999 7.26338 9.41543L9.82414 14.8215C9.86817 14.9144 9.93951 14.9917 10.0286 15.043C10.1178 15.0943 10.2204 15.1172 10.3229 15.1086C10.4254 15.1 10.5228 15.0603 10.6022 14.9949C10.6815 14.9294 10.739 14.8413 10.7669 14.7424L14.0855 2.97635C14.1099 2.88993 14.1108 2.79856 14.0881 2.71167C14.0654 2.62478 14.02 2.54551 13.9565 2.48201C13.893 2.41851 13.8137 2.37309 13.7268 2.35041C13.64 2.32774 13.5486 2.32864 13.4622 2.35301Z",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18652 9.25241L10.0442 6.39471",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fa98f73ee66a0a81d3dc85ba5f4ef018.svg";
export { ForwardRef as ReactComponent };